export default __webpack_public_path__ + "static/media/b5.837533ce.svg";